/**
 * Le contrat d'identification de ligne d'`app-table`, cote consommateur.
 *
 * `app-table` pose `data-testid="table-row-<id>"` sur chaque `<tr>`. Le menu
 * contextuel (clic droit) s'en sert pour retrouver la ligne visee, plutot que
 * d'ajouter une sortie au kit.
 *
 * ⚠️ Le kit n'exporte AUCUNE constante pour ce prefixe : il l'ecrit en clair a
 * quatre endroits de `table.component.ts`. Une resynchronisation qui le renomme
 * ferait donc tomber le clic droit **en silence** — le `if (!ligne) return;` des
 * appelants avale le cas. Le prefixe est donc centralise ici, et
 * `ligne-table.spec.ts` verifie le contrat sur le rendu REEL d'`app-table` : il
 * echoue a la resynchronisation au lieu de laisser le geste mourir sans bruit.
 */
const PREFIXE_LIGNE = 'table-row-';

/** Selecteur des `<tr>` d'`app-table`, pour un `closest()`. */
export const SELECTEUR_LIGNE_TABLE = `[data-testid^="${PREFIXE_LIGNE}"]`;

/**
 * Identifiant de la ligne d'`app-table` contenant la cible d'un evenement, ou
 * `undefined` si l'evenement n'a pas eu lieu dans une ligne.
 */
export function idLigneDepuisEvenement(evenement: Event): string | undefined {
  const ligne = (evenement.target as HTMLElement | null)?.closest<HTMLElement>(SELECTEUR_LIGNE_TABLE);
  const testid = ligne?.dataset['testid'];
  return testid?.startsWith(PREFIXE_LIGNE) ? testid.slice(PREFIXE_LIGNE.length) : undefined;
}

/** Ce que le kit doit poser pour un identifiant donne. Utilise par la spec de contrat. */
export function testidLigneAttendu(id: string): string {
  return `${PREFIXE_LIGNE}${id}`;
}
